import { PlanListProvider } from './../../../../../shared/cw-backend/providers/accreditation/plan/plan-list.provider';
import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { InsuranceListProvider } from "../../../../../shared/cw-backend/providers/accreditation/insurance/insurance-list.provider";
import { PageOptions } from "../../../../../shared/cw-utils/cw-utils.service";
import { HttpResponse } from "@angular/common/http";
import {
    Alert,
    AlertSearch,
    Insurance,
    Plan,
    Professional,
} from "../../../../../shared/cw-backend/models/backend-definitions.module";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { AlertListProvider } from "../../../../../shared/cw-backend/providers/operational-system/alert/alert-list.provider";
import { fuseAnimations } from "@fuse/animations";
import { AttendanceListProvider } from "../../../../../shared/cw-backend/providers/attendance/attendance/attendance-list.provider";
import { AccreditationListProvider, ApiGateway } from 'cw-backend';

@Component({
    selector: "app-general-information",
    templateUrl: "./general-information.component.html",
    styleUrls: ["./general-information.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class GeneralInformationComponent implements OnInit {
    loading: boolean = false;
    selectedTabIndex: number;
    typeControl = new FormControl("1");
    generalInformationForm: FormGroup;
    alertForm = new FormControl();
    insurance = new Insurance();
    procedureForm = new FormControl();
    emailSearchForm = new FormControl();
    emailStatusControl = new FormControl("");
    //listagens
    insuranceList: Insurance[];
    planList: Plan[];
    accreditationProcedureList: any[];
    emailList: any[] = [];
    alertList = new Array<Alert>();
    professionalList = new Array<Professional>();

    //page options
    insurancePageOptions: PageOptions;
    professionalPageOptions: PageOptions;
    accreditationProcedurePageOptions: PageOptions;
    planPageOptions: PageOptions;
    emailPageOptions: any;

    private _unsubscribeAll: Subject<any>;

    public totalElements = 0;
    public pagina = 0;
    public tamanho = 0;
    public emailTotalElements = 0;
    public emailPagina = 0;
    public emailTamanho = 0;
    public emailLoading = false;

    emailStatusOptions = [
        { value: "", label: "Todos" },
        { value: "PENDING", label: "Pendente" },
        { value: "ACCEPTED", label: "Aceito" },
        { value: "PROCESSED", label: "Processado" },
        { value: "DELIVERED", label: "Entregue" },
        { value: "OPENED", label: "Aberto" },
        { value: "CLICKED", label: "Clique" },
        { value: "DEFERRED", label: "Adiado" },
        { value: "BOUNCED", label: "Bounce" },
        { value: "DROPPED", label: "Descartado" },
        { value: "SPAM_REPORTED", label: "Spam" },
        { value: "UNSUBSCRIBED", label: "Descadastro" },
        { value: "GROUP_UNSUBSCRIBED", label: "Descadastro grupo" },
        { value: "GROUP_RESUBSCRIBED", label: "Recadastro grupo" },
        { value: "FAILED", label: "Falhou" },
        { value: "UNKNOWN", label: "Desconhecido" },
    ];

    configEditor = {
        toolbar: [
        ],
    };

    constructor(
        public dialogRef: MatDialogRef<GeneralInformationComponent>,
        private insuranceListProvider: InsuranceListProvider,
        private AttendanceListProvider: AttendanceListProvider,
        private alertListProvider: AlertListProvider,
        private planListProvider: PlanListProvider,
        private accreditationListProvider: AccreditationListProvider,
        private gw: ApiGateway,
        private _formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.insurancePageOptions = new PageOptions();
        this.insurancePageOptions.fieldSort = "name";
        this.insurancePageOptions.page = 0;
        this.insurancePageOptions.sizePage = 10;
        this.insurancePageOptions.argument = ""

        this.planPageOptions = new PageOptions();
        this.planPageOptions.fieldSort = "name";
        this.planPageOptions.page = 0;
        this.planPageOptions.sizePage = 10;
        this.planPageOptions.argument = ""

        this.professionalPageOptions = new PageOptions();
        this.professionalPageOptions.fieldSort = "person.name";
        this.professionalPageOptions.page = 0;
        this.professionalPageOptions.sizePage = 10;
        this.professionalPageOptions.argument = ""

        this.accreditationProcedurePageOptions = new PageOptions();
        this.accreditationProcedurePageOptions.fieldSort = "name";
        this.accreditationProcedurePageOptions.page = 0;
        this.accreditationProcedurePageOptions.sizePage = 10;
        this.accreditationProcedurePageOptions.argument = ""

        this.emailPageOptions = {
            page: 0,
            sizePage: 10,
            fieldSort: "requestedAt",
            sortDirection: "DESC",
            email: "",
            subject: "",
            status: "",
        };

        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.generalInformationForm = this.createSurgeryScheduleForm();
        this.getAll();
        this.filterAll();
        this.filterEmailList();

        this.typeControl.valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((value) => {
                if (value === "3") {
                    this.getEmailList();
                }
            });
    }

    dimiss() {
        this.dialogRef.close();
    }

    getAll() {
        this.getInsurance();
        this.getProfessionalList();
    }

    filterAll() {
        this.filterInsurance();
        this.filterProfessional();
        this.filterAccreditationProcedure();
    }

    filterEmailList() {
        this.emailSearchForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((value) => {
                this.emailPageOptions.email = value || "";
                this.emailPageOptions.subject = "";
                this.getEmailList();
            });

        this.emailStatusControl.valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((status) => {
                this.emailPageOptions.status = status || "";
                this.getEmailList();
            });
    }

    getInsurance() {
        this.insuranceListProvider
            .getPageSimpleList(this.insurancePageOptions)
            .then((res) => {
                this.insuranceList = res.body.content;
            });
    }

    filterInsurance() {
        this.generalInformationForm.controls["insurance"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {

                if (res && res.id) {
                    this.insurance = res;
                    this.insurancePageOptions.argument = res.name;
                    this.getPlanList(res.id);
                    this.getAccreditationProcedureList();
                    this.generalInformationForm.controls["professional"].setValue(null);
                    this.getAlerts();
                } else if (res && typeof res === "string") {
                    this.insurancePageOptions.argument = res;
                } else {
                    this.insurancePageOptions.argument = "";
                }

                this.getInsurance();
            });
    }

    filterAccreditationProcedure() {
        this.procedureForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {

                if (res && res.id) {
                    this.accreditationProcedurePageOptions.argument = res.name;
                } else if (res && typeof res === "string") {
                    this.accreditationProcedurePageOptions.argument = res;
                } else {
                    this.accreditationProcedurePageOptions.argument = "";
                }

                this.getAccreditationProcedureList();
            });
    }

    displayInsuranceFn(insurance?: any): string | undefined {
        if (!insurance) {
            return "";
        }
        if (insurance.name) {
            return insurance.name;
        }
        return insurance.name;
    }

    createSurgeryScheduleForm(): FormGroup {
        return this._formBuilder.group({
            insurance: new FormControl(null),
            professional: new FormControl(null),
        });
    }

    changeViewByTab(tab) {
        this.getAlerts();
        this.selectedTabIndex = tab;

        this.alertForm.setValue(this.alertList[this.selectedTabIndex].content);

    }

    getAlerts() {
        let alertSearch = new AlertSearch();

        alertSearch.insuranceId = this.generalInformationForm.controls["insurance"]?.value?.id;
        alertSearch.professionalId = this.generalInformationForm.controls["professional"]?.value?.id;
        alertSearch.index = 6;

        this.alertListProvider.getFindModule(alertSearch).then(async (res) => {
            console.log("🚀 ~ GeneralInformationComponent ~ this.alertListProvider.getFindModule ~ res:", res)
            this.alertList = new Array<Alert>();
            if (res.body.length > 0) {
                this.alertList = res.body.sort((a, b) => a.sequence - b.sequence);;
                this.alertForm.setValue(this.alertList[0].content);
                await new Promise((resolve) => setTimeout(resolve, 100));

                this.alertForm.disable()

            } else {
                this.alertForm.setValue("");
            }
        });
    }

    async getProfessionalList() {
        await this.AttendanceListProvider.getProfessional(
            this.professionalPageOptions
        ).then((res) => {
            this.professionalList = res.body.content;
        });
    }

    filterProfessional() {
        this.generalInformationForm.controls['professional']
            .valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            ).subscribe({
                next: (res => {
                    if (res && res.id) {
                        this.professionalPageOptions.argument = res.name;
                        this.generalInformationForm.controls["insurance"].setValue(null);
                        this.getAlerts();
                    } else if (res && typeof res === "string") {
                        this.professionalPageOptions.argument = res;
                    } else {
                        this.professionalPageOptions.argument = "";
                    }
                    this.getProfessionalList();
                })
            })
    }

    displayPerformerFn(performer?: any): string | undefined {
        if (!performer) {
            return "";
        }
        if (performer.professional) {
            return performer.professional.person.name;
        }
        return performer.person.name;
    }

    getPlanList(insuranceId) {
        this.planListProvider.getPlanSimpleList(insuranceId, this.planPageOptions).then(res => {
            console.log(res)
            this.planList = res.body;
        })
    }

    getAccreditationProcedureList(event?, type?) {

        switch (type) {
            case "short":
                this.accreditationProcedurePageOptions.fieldSort = event.active;
                this.accreditationProcedurePageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.accreditationProcedurePageOptions.page = event.pageIndex;
                this.accreditationProcedurePageOptions.sizePage = event.pageSize;
                break;

            default:
                this.accreditationProcedurePageOptions.page = 0;
                this.accreditationProcedurePageOptions.sizePage = 5;
                break;
        }

        this.accreditationListProvider.getPageByProcedureIdAndInsuranceAndCompanyId(this.insurance.id, this.accreditationProcedurePageOptions).then(res => {
            console.log(res)
            this.accreditationProcedureList = res.body.content;
            const dados = res.body;
            this.totalElements = dados.totalElements;
            this.pagina = dados.number;
        })
    }

    getEmailList(event?, type?) {
        switch (type) {
            case "page":
                this.emailPageOptions.page = event.pageIndex;
                this.emailPageOptions.sizePage = event.pageSize;
                break;

            default:
                this.emailPageOptions.page = 0;
                break;
        }

        this.emailLoading = true;

        this.gw.post("email/search", this.emailPageOptions).subscribe({
            next: (res: HttpResponse<any>) => {
                const dados = res.body;
                this.emailList = dados?.content || [];
                this.emailTotalElements = dados?.totalElements || 0;
                this.emailPagina = dados?.number || 0;
                this.emailTamanho = dados?.size || this.emailPageOptions.sizePage;
                this.emailLoading = false;
            },
            error: () => {
                this.emailList = [];
                this.emailLoading = false;
            }
        });
    }

    getEmailStatusLabel(status: string): string {
        const option = this.emailStatusOptions.find(item => item.value === status);
        return option ? option.label : (status || "Desconhecido");
    }

    getEmailStatusIcon(status: string): string {
        switch (status) {
            case "PENDING": return "schedule";
            case "ACCEPTED": return "check_circle";
            case "PROCESSED": return "settings";
            case "DELIVERED": return "mark_email_read";
            case "OPENED": return "drafts";
            case "CLICKED": return "touch_app";
            case "DEFERRED": return "pause_circle_filled";
            case "BOUNCED": return "reply";
            case "DROPPED": return "block";
            case "SPAM_REPORTED": return "report";
            case "UNSUBSCRIBED": return "unsubscribe";
            case "GROUP_UNSUBSCRIBED": return "unsubscribe";
            case "GROUP_RESUBSCRIBED": return "mark_email_read";
            case "FAILED": return "error";
            default: return "help";
        }
    }

    getEmailStatusTooltip(status: string): string {
        switch (status) {
            case "PENDING": return "Pendente: o envio foi registrado localmente, mas ainda nao foi aceito pelo SendGrid.";
            case "ACCEPTED": return "Aceito: o SendGrid recebeu a requisicao de envio.";
            case "PROCESSED": return "Processado: o SendGrid processou a mensagem para entrega.";
            case "DELIVERED": return "Entregue: o servidor do destinatario aceitou o e-mail.";
            case "OPENED": return "Aberto: o destinatario abriu o e-mail.";
            case "CLICKED": return "Clique: o destinatario clicou em algum link do e-mail.";
            case "DEFERRED": return "Adiado: o servidor do destinatario pediu nova tentativa de entrega.";
            case "BOUNCED": return "Bounce: o e-mail voltou e nao foi entregue.";
            case "DROPPED": return "Descartado: o SendGrid descartou a mensagem antes de enviar.";
            case "SPAM_REPORTED": return "Spam: o destinatario marcou a mensagem como spam.";
            case "UNSUBSCRIBED": return "Descadastrado: o destinatario solicitou descadastro.";
            case "GROUP_UNSUBSCRIBED": return "Descadastrado do grupo: o destinatario saiu de um grupo de envio.";
            case "GROUP_RESUBSCRIBED": return "Recadastrado no grupo: o destinatario voltou para um grupo de envio.";
            case "FAILED": return "Falhou: ocorreu erro ao tentar enviar para o SendGrid.";
            default: return "Status desconhecido.";
        }
    }

    isEmailFailure(status: string): boolean {
        return ["FAILED", "BOUNCED", "DROPPED", "SPAM_REPORTED"].includes(status);
    }

    highlightText(value: string): string {
        if (!value) {
            return '-';
        }

        const search = this.procedureForm?.value;

        if (!search || !search.trim()) {
            return value;
        }

        const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        return value.replace(
            new RegExp(`(${escapedSearch})`, 'gi'),
            '<mark>$1</mark>'
        );
    }
}
